import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: [],
}

export const template: any = createSlice({
    name: 'TEMPLATE',
    initialState,
    reducers: {
        setTemplates: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setTemplates } = template.actions

export default template.reducer
